import { BrowserRouter, Route, Routes } from "react-router-dom";
import { LayoutSite } from "./components/layout";
import { BatchPage } from "./pages/batch";
import { SshPage } from "./pages/ssh";
import { LoginPage } from "./pages/login";
import { AuthProvider } from "./services/auth.service";
import "./app.scss";

/* -------------------------------------------------------------------------------- *\
|                               App
\* -------------------------------------------------------------------------------- */
export default function App()
{
    return (
        <BrowserRouter basename="/">
            <AuthProvider>
                <Routes>
                    <Route path="/" element={<BatchPage />} />
                    <Route path="/batch" element={<BatchPage />} />
                    <Route path="/ssh" element={<SshPage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="*" element={<LayoutSite><p>Wrong page</p></LayoutSite>} />
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}
